import CodexBlockRenderer from '../CodexBlockRenderer'

function CodexPreviewPane({ draft }) {
  if (!draft) return null
  return (
    <section className="codex-admin-preview">
      <h3>Aperçu élève</h3>
      <article className="codex-admin-preview-card">
        <h2>{draft.title || 'Sans titre'}</h2>
        <p>{draft.shortDescription || ''}</p>
        {(draft.contentBlocks || []).map((block, idx) => (
          <CodexBlockRenderer key={`${block.type}-${idx}`} block={block} />
        ))}
      </article>
    </section>
  )
}

export default CodexPreviewPane
